import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import CredentialCard from './pages/CredentialCard';
import Navbar from './Components/Navbar2';
import Sales from './pages/Sales';
import CaseStudy from './pages/CaseStudy';
import Blog from './pages/Blog';
import ScrollToTop from './pages/ScrollToTop';
import Backdrop from "./adminPanelSRC/components/Backdrop/Backdrop";
import Layout from "./adminPanelSRC/components/Layout/Layout";
import Toolbar from "./adminPanelSRC/components/Toolbar/Toolbar";
import MainNavigation from "./adminPanelSRC/components/Navigation/MainNavigation/MainNavigation";
import MobileNavigation from "./adminPanelSRC/components/Navigation/MobileNavigation/MobileNavigation";
import FeedPage from "./adminPanelSRC/pages/Feed/BlogEditor";
import TestimonialAdmin from "./adminPanelSRC/pages/Feed/Testimonial";
import LoginPage from "./adminPanelSRC/pages/Auth/Login";
import ServiceAdmin from "./adminPanelSRC/pages/Feed/Service";
import BlogAdmin from "./adminPanelSRC/pages/Feed/Blog";
import AreaOfExpertiseAdmin from "./adminPanelSRC/pages/Feed/AreaOfExpertise";
import CaseStudyAdmin from "./adminPanelSRC/pages/Feed/CaseStudy";
import ContactUsAdmin from "./adminPanelSRC/pages/Feed/ContactUs";
import GetPublicUrlOfImage from './adminPanelSRC/pages/Feed/GetPublicUrlOfImages';
// Preserve legacy style imports used by the protected customer stories.
import "./MainPage";
import Achievements from "./adminPanelSRC/pages/Feed/Achievements";
import Leets from "./adminPanelSRC/pages/Feed/Leets";
import About from "./Components/About";
import BlogD from "./pages/BlogD";
import HRM from "./HRMPanel/HRM";
import HrmRoninPage from "./HRMPanel/newHrm/components/HrmRoninPage";
import EmployeeManagement from "./adminPanelSRC/pages/Feed/EmployeeManagement";
import EmployeesPolicies from "./adminPanelSRC/pages/Feed/EmployeesPolicies";
import MainFooter from "./Components/MainFooter";
import { servicesData } from "./Components/serviceMetaData";
import Article from "./Components/Article";
import JobSearch from "./pages/JobSearch";
import Careers from "./pages/Careers";
import EdiConverter from "./pages/EdiConverter";
import CookieConsent from "./CookieConsent";
import PrivacyAndPolicy from "./Components/PrivacyAndPolicy";
import AdminStory from "./adminPanelSRC/pages/Feed/AdminStory.js";
import Events from "./pages/Events";
import CaseStudiesLibrary from "./pages/CaseStudiesLibrary";
import SowPortal from "./pages/SowPortal";
import PublicSeo from "./seo/RouteSeo";
import NotFound from "./pages/NotFound";
import VoicesHome from './voices/VoicesHome';
import VoicesContact from './voices/VoicesContact';
import VoicesDirectory from './voices/VoicesDirectory';
import VoicesSolutions from './voices/VoicesSolutions';
import { voicesSolutionsMetadata } from './voices/voicesSolutionsData';
import { isVoicesRoute } from './voices/voicesRoutes';
import VoicesBlogsContext from './voices/VoicesBlogsContext';
import VoicesStartup from './voices/VoicesStartup';
import VoicesThemeShell from './voices/VoicesTheme';
import './voices/voices-base.css';
import './voices/voices-shell.css';
import './voices/voices-directory.css';
import './voices/voices-home.css';
import './voices/voices-interiors.css';
import './voices/voices-dark.css';
import './voices/voices-dark-interiors.css';
import './voices/voices-theme.css';

const LEGACY_HRM_BASE = "/DjUcNcbvQ0PZ9KGjn3t6OEmC7lq5dO0ckborXyZVTnU0Gd5OPJMjpwLKC48QwHAqcXLWVBnXC5fFwMjNzCNGp5C8fcZ9U7friZIp";
const JACOBS_ENGAGEMENT_ROUTE = "/e/jacobs-al";
const RIOMAX_ENGAGEMENT_ROUTE = "/e/riomax";

function App() {
	const location = useLocation();
	const [showBackdrop, setShowBackdrop] = useState(false);
	const [showMobileNav, setShowMobileNav] = useState(false);
	const [isAuth, setIsAuth] = useState(false);
	const [token, setToken] = useState(null);
	const [userId, setUserId] = useState(null);
	const [authLoading, setAuthLoading] = useState(false);
	const [error, setError] = useState(null);
	const [navigationUrl, setNavigatonUrl] = useState(window.location.pathname);
	const currentPath = location.pathname;
	const normalizedPath = currentPath.toLowerCase().replace(/\/+$/, "") || "/";
	const isHrmRoute =
		normalizedPath === "/hrm" ||
		normalizedPath === "/hrm/ronin" ||
		normalizedPath.startsWith(`${LEGACY_HRM_BASE.toLowerCase()}/hrmloginpage`) ||
		normalizedPath.startsWith(`${LEGACY_HRM_BASE.toLowerCase()}/adminpanelhrm`);
	const isSowRoute =
		normalizedPath === "/e" ||
		normalizedPath.startsWith("/e/") ||
		normalizedPath === "/sow" ||
		normalizedPath.startsWith("/sow/");
	// const [allServices, setallServices] = useState([]);


	const [allBlogs, setAllBlogs] = useState([]);
	const [blogsLoading, setBlogsLoading] = useState(true);
	const [blogsError, setBlogsError] = useState(false);
	const [blogReloadKey, setBlogReloadKey] = useState(0);
	/*
	*********************************************************************************************************
	*   @React Component Name       :       App
	*   @Method                     :       useEffect
	*   @Author                     :       <Bajrang Mahawar>(bajrang.mahawar@antrazal.com)
	*   @Company                    :       Antrazal
	*   @Description                :       login  chack or for the panel 
	*********************************************************************************************************
	*/
	useEffect(() => {
		const token = localStorage.getItem('token');
		const expiryDate = localStorage.getItem('expiryDate');
		if (token && expiryDate && new Date(expiryDate) > new Date()) {
			const userId = localStorage.getItem('userId');
			const remainingMilliseconds = new Date(expiryDate).getTime() - new Date().getTime();
			setIsAuth(true);
			setToken(token);
			setUserId(userId);
			setAutoLogout(remainingMilliseconds);
		}

	}, []);


	useEffect(() => {
		if (isSowRoute || isHrmRoute) {
			return;
		}
		const controller = new AbortController();
		let active = true;
		setBlogsLoading(true);
		setBlogsError(false);
		const timeout = setTimeout(() => controller.abort(), 30000);
		fetch(`${process.env.REACT_APP_PRODUCTION_API_URL}/backend/api/v1.0/AntrazalSolutionsPrivatelimited/blog`, { signal: controller.signal })
				.then((res) => {
					if (!res.ok) throw new Error('Articles could not be loaded.');
					return res.json();
				})
				.then((resData) => {
					if (!Array.isArray(resData)) throw new Error('Invalid article response.');
					if (active) setAllBlogs(resData);
				})
				.catch(() => {
					if (active) setBlogsError(true);
				})
				.finally(() => {
					clearTimeout(timeout);
					if (active) setBlogsLoading(false);
				});
		return () => {
			active = false;
			clearTimeout(timeout);
			controller.abort();
		};
	}, [isSowRoute, isHrmRoute, blogReloadKey]);





	/*
*********************************************************************************************************
*   @React Component Name       :       App
*   @Method                     :       mobileNavHandler
*   @Author                     :       <Bajrang Mahawar>(bajrang.mahawar@antrazal.com)
*   @Company                    :       Antrazal
*   @Description                :       mobile navigation of the admin panel 
*********************************************************************************************************
*/

	const mobileNavHandler = (isOpen) => {
		setShowMobileNav(isOpen);
		setShowBackdrop(isOpen);
	};

	/*
*********************************************************************************************************
*   @React Component Name       :       App
*   @Method                     :       backdropClickHandler
*   @Author                     :       <Bajrang Mahawar>(bajrang.mahawar@antrazal.com)
*   @Company                    :       Antrazal
*   @Description                :       set the state for the backdrop or navigation on the admin page 
*********************************************************************************************************
*/

	const backdropClickHandler = () => {
		setShowBackdrop(false);
		setShowMobileNav(false);
		setError(null);
	};

	/*
*********************************************************************************************************
*   @React Component Name       :       App
*   @Method                     :       logoutHandler
*   @Author                     :       <Bajrang Mahawar>(bajrang.mahawar@antrazal.com)
*   @Company                    :       Antrazal
*   @Description                :       logout handlere for the admin panle page 
*********************************************************************************************************
*/

	const logoutHandler = () => {
		setIsAuth(false);
		setToken(null);
		localStorage.removeItem('token');
		localStorage.removeItem('expiryDate');
		localStorage.removeItem('userId');
	};

	/*
	*********************************************************************************************************
	*   @React Component Name       :       App
	*   @Method                     :       loginHandler
	*   @Author                     :       <Bajrang Mahawar>(bajrang.mahawar@antrazal.com)
	*   @Company                    :       Antrazal
	*   @Description                :       login button handler for admin panel
	*********************************************************************************************************
	*/

	const loginHandler = (event, authData) => {
		event.preventDefault();
		setAuthLoading(true);
		fetch(`${process.env.REACT_APP_PRODUCTION_API_URL}/backend/api/v1.0/AntrazalSolutionsPrivatelimited/user`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				email: authData.email,
				password: authData.password,
			})
		})
			.then((res) => {
				if (res.status === 422) {
					throw new Error('Validation failed.');
				}
				if (res.status !== 200 && res.status !== 201) {
					throw new Error('Could not authenticate you!');
				}
				return res.json();
			})
			.then((resData) => {
				setIsAuth(true);
				setToken(resData.id);
				setAuthLoading(false);
				setUserId(resData.id);
				localStorage.setItem('token', resData.id);
				localStorage.setItem('userId', resData.id);
				const remainingMilliseconds = 60 * 60 * 1000;
				const expiryDate = new Date(new Date().getTime() + remainingMilliseconds);
				localStorage.setItem('expiryDate', expiryDate.toISOString());
				setAutoLogout(remainingMilliseconds);
			})
			.catch((err) => {
				alert("Your details is unauthorized", err.message);
				console.log(err);
				setIsAuth(false);
				setAuthLoading(false);
				setError(err);
			});
	};

	/*
	*********************************************************************************************************
	*   @React Component Name       :       App
	*   @Method                     :       setAutoLogout
	*   @Author                     :       <Bajrang Mahawar>(bajrang.mahawar@antrazal.com)
	*   @Company                    :       Antrazal
	*   @Description                :       Admin page logout handler
	*********************************************************************************************************
	*/

	const setAutoLogout = (milliseconds) => {
		setTimeout(() => {
			logoutHandler();
		}, milliseconds)
	};

const toSlug = (str) =>
  str
    .toLowerCase()
    .trim()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
	return (
		<VoicesBlogsContext.Provider value={allBlogs}>
    <VoicesThemeShell enabled={isVoicesRoute(currentPath)}>
			<VoicesStartup />
			<PublicSeo blogs={allBlogs} blogsLoading={blogsLoading} blogsError={blogsError} />
			{!isSowRoute && !isHrmRoute && <CookieConsent/>}
			<ScrollToTop />
			{
				isAuth && navigationUrl.startsWith("/DjUcNcbvQ0PZ9KGjn3t6OEmC7lq5dO0ckborXyZVTnU0Gd5OPJMjpwLKC48QwHAqcXLWVBnXC5fFwMjNzCNGp5C8fcZ9U7friZIp/antrazal/admin") ? (
					<Layout
						header={
							<Toolbar>
								<MainNavigation
									onOpenMobileNav={() => mobileNavHandler(true)}
									onLogout={logoutHandler}
									isAuth={isAuth}
								/>
							</Toolbar>
						}
						mobileNav={
							<MobileNavigation
								open={showMobileNav}
								mobile
								onChooseItem={() => mobileNavHandler(false)}
								onLogout={logoutHandler}
								isAuth={isAuth}
							/>
						}
					/>
				) : (
					(isAuth || localStorage.getItem('authTokenForGoogleLogin') == 'true') && navigationUrl.startsWith("/DjUcNcbvQ0PZ9KGjn3t6OEmC7lq5dO0ckborXyZVTnU0Gd5OPJMjpwLKC48QwHAqcXLWVBnXC5fFwMjNzCNGp5C8fcZ9U7friZIp/adminPanelHrm") ? (
						<>
						</>
					) : (
						// <Navbar />
						<></>
					)
				)
			}
			<Routes>

				<Route path="/" element={<VoicesHome />} />
				<Route path="/services" element={<><Navbar /><VoicesDirectory kind="services" /></>} />
				<Route path="/work" element={<><Navbar /><VoicesDirectory kind="work" /></>} />
				<Route path="/site-map" element={<><Navbar /><VoicesDirectory kind="site-map" blogs={allBlogs} /></>} />
				<Route path="/contact" element={<VoicesContact />} />
				{voicesSolutionsMetadata.map(page => <Route key={page.path} path={page.path} element={<><Navbar /><VoicesSolutions /></>} />)}
				<Route path={JACOBS_ENGAGEMENT_ROUTE} element={<SowPortal requestedProjectSlug="jacobs" />} />
				<Route path={RIOMAX_ENGAGEMENT_ROUTE} element={<SowPortal requestedProjectSlug="riomax" />} />
				<Route
					path={`${RIOMAX_ENGAGEMENT_ROUTE}/*`}
					element={<Navigate replace to={`${RIOMAX_ENGAGEMENT_ROUTE}${location.search}${location.hash}`} />}
				/>
				<Route
					path="/e/*"
					element={<Navigate replace to={`${JACOBS_ENGAGEMENT_ROUTE}${location.search}${location.hash}`} />}
				/>
				<Route path="/sow/*" element={<Navigate replace to={JACOBS_ENGAGEMENT_ROUTE} />} />
				<Route path="/privacy-policy" element={<PrivacyAndPolicy />} />
					<Route path="/admin/story" element={<AdminStory />} />
				{servicesData && servicesData.length > 0 &&
					servicesData.map((service) => (
						service?.name && (
							<Route
								key={service.id}
								// path={`/services/:${service.name
								// 	.toLowerCase().replace(/\s+/g, '-')}`}
								   path={`/services/${toSlug(service.name)}`}
								element={<Sales />}
							/>
						)
					))
				}

				<Route path="/customer-stories/:name" element={<Blog />} />
					<Route path="/who-we-are" element={<About />} />
					<Route path="/careers" element={<Careers />} />
					<Route path="/career" element={<Navigate to="/careers" replace />} />
					<Route path="/products/edi-converter" element={<EdiConverter />} />
					<Route path="/edi-converter" element={<Navigate to="/products/edi-converter" replace />} />
					<Route path="/events" element={<Events />} />
					<Route path="/case-studies" element={<CaseStudiesLibrary />} />
					<Route path="/article/:name" element={<Article />} />

				<Route path="/blog/:name" element={<BlogD posts={allBlogs} loading={blogsLoading} error={blogsError} onRetry={() => setBlogReloadKey((key) => key + 1)} />} />


				<Route path="/hrm/ronin" element={<HrmRoninPage />} />
				<Route path="/HRM" element={<HRM />} />
				<Route path="/hrm" element={<Navigate to="/HRM" replace />} />
				<Route path={`${LEGACY_HRM_BASE}/hrmLoginPage`} element={<Navigate to="/HRM" replace />} />
				<Route path={`${LEGACY_HRM_BASE}/adminPanelHrm`} element={<Navigate to="/HRM" replace />} />
				<Route path={`${LEGACY_HRM_BASE}/adminPanelHrm/*`} element={<Navigate to="/HRM" replace />} />
				<Route path="*" element={<NotFound />} />
				{showBackdrop && <Backdrop onClick={backdropClickHandler} />}
				<Route
					path="/DjUcNcbvQ0PZ9KGjn3t6OEmC7lq5dO0ckborXyZVTnU0Gd5OPJMjpwLKC48QwHAqcXLWVBnXC5fFwMjNzCNGp5C8fcZ9U7friZIp/antrazal/admin/"
					element={
						isAuth ? (
							<>
								<FeedPage userId={userId} token={token} />
							</>
						) : (
							<LoginPage onLogin={loginHandler} loading={authLoading} />
						)
					}
				/>
				<Route
					path="/DjUcNcbvQ0PZ9KGjn3t6OEmC7lq5dO0ckborXyZVTnU0Gd5OPJMjpwLKC48QwHAqcXLWVBnXC5fFwMjNzCNGp5C8fcZ9U7friZIp/antrazal/admin/testimonial"
					element={
						isAuth ? (
							<>
								<TestimonialAdmin />
							</>
						) : (
							<LoginPage onLogin={loginHandler} loading={authLoading} />
						)
					}
				/>
				<Route
					path="/DjUcNcbvQ0PZ9KGjn3t6OEmC7lq5dO0ckborXyZVTnU0Gd5OPJMjpwLKC48QwHAqcXLWVBnXC5fFwMjNzCNGp5C8fcZ9U7friZIp/antrazal/admin/service"
					element={
						isAuth ? (
							<>
								<ServiceAdmin />
							</>
						) : (
							<LoginPage onLogin={loginHandler} loading={authLoading} />
						)
					}
				/>
				<Route
					path="/DjUcNcbvQ0PZ9KGjn3t6OEmC7lq5dO0ckborXyZVTnU0Gd5OPJMjpwLKC48QwHAqcXLWVBnXC5fFwMjNzCNGp5C8fcZ9U7friZIp/antrazal/admin/blog"
					element={
						isAuth ? (
							<>
								<BlogAdmin />
							</>
						) : (
							<LoginPage onLogin={loginHandler} loading={authLoading} />
						)
					}
				/>
				<Route
					path="/DjUcNcbvQ0PZ9KGjn3t6OEmC7lq5dO0ckborXyZVTnU0Gd5OPJMjpwLKC48QwHAqcXLWVBnXC5fFwMjNzCNGp5C8fcZ9U7friZIp/antrazal/admin/employeManagement"
					element={
						isAuth ? (
							<>
								<EmployeeManagement />
							</>
						) : (
							<LoginPage onLogin={loginHandler} loading={authLoading} />
						)
					}
				/>
				<Route
					path="/DjUcNcbvQ0PZ9KGjn3t6OEmC7lq5dO0ckborXyZVTnU0Gd5OPJMjpwLKC48QwHAqcXLWVBnXC5fFwMjNzCNGp5C8fcZ9U7friZIp/antrazal/admin/policies"
					element={
						isAuth ? (
							<>
								<EmployeesPolicies />
							</>
						) : (
							<LoginPage onLogin={loginHandler} loading={authLoading} />
						)
					}
				/>
				<Route
					path="/DjUcNcbvQ0PZ9KGjn3t6OEmC7lq5dO0ckborXyZVTnU0Gd5OPJMjpwLKC48QwHAqcXLWVBnXC5fFwMjNzCNGp5C8fcZ9U7friZIp/antrazal/admin/areasOfOurExpertise"
					element={
						isAuth ? (
							<>
								<AreaOfExpertiseAdmin />
							</>
						) : (
							<LoginPage onLogin={loginHandler} loading={authLoading} />
						)
					}
				/>
				<Route
					path="/DjUcNcbvQ0PZ9KGjn3t6OEmC7lq5dO0ckborXyZVTnU0Gd5OPJMjpwLKC48QwHAqcXLWVBnXC5fFwMjNzCNGp5C8fcZ9U7friZIp/antrazal/admin/caseStudy"
					element={
						isAuth ? (
							<>
								<CaseStudyAdmin />
							</>
						) : (
							<LoginPage onLogin={loginHandler} loading={authLoading} />
						)
					}
				/>
				<Route
					path="/DjUcNcbvQ0PZ9KGjn3t6OEmC7lq5dO0ckborXyZVTnU0Gd5OPJMjpwLKC48QwHAqcXLWVBnXC5fFwMjNzCNGp5C8fcZ9U7friZIp/antrazal/admin/getpublicUrlOfImges"
					element={
						isAuth ? (
							<>
								<GetPublicUrlOfImage />
							</>
						) : (
							<LoginPage onLogin={loginHandler} loading={authLoading} />
						)
					}
				/>
				<Route
					path="/DjUcNcbvQ0PZ9KGjn3t6OEmC7lq5dO0ckborXyZVTnU0Gd5OPJMjpwLKC48QwHAqcXLWVBnXC5fFwMjNzCNGp5C8fcZ9U7friZIp/antrazal/admin/contactUs"
					element={
						isAuth ? (
							<>
								<ContactUsAdmin />
							</>
						) : (
							<LoginPage onLogin={loginHandler} loading={authLoading} />
						)
					}
				/>
				<Route
					path="/DjUcNcbvQ0PZ9KGjn3t6OEmC7lq5dO0ckborXyZVTnU0Gd5OPJMjpwLKC48QwHAqcXLWVBnXC5fFwMjNzCNGp5C8fcZ9U7friZIp/antrazal/admin/achievements"
					element={
						isAuth ? (
							<>
								<Achievements />
							</>
						) : (
							<LoginPage onLogin={loginHandler} loading={authLoading} />
						)
					}
				/>
				<Route
					path="/DjUcNcbvQ0PZ9KGjn3t6OEmC7lq5dO0ckborXyZVTnU0Gd5OPJMjpwLKC48QwHAqcXLWVBnXC5fFwMjNzCNGp5C8fcZ9U7friZIp/antrazal/admin/leets"
					element={
						isAuth ? (
							<>
								<Leets />
							</>
						) : (
							<LoginPage onLogin={loginHandler} loading={authLoading} />
						)
					}
				/>
			</Routes>
			{/* {
				isAuth || (localStorage.getItem('authTokenForGoogleLogin') == 'true' && navigationUrl.startsWith("/DjUcNcbvQ0PZ9KGjn3t6OEmC7lq5dO0ckborXyZVTnU0Gd5OPJMjpwLKC48QwHAqcXLWVBnXC5fFwMjNzCNGp5C8fcZ9U7friZIp/adminPanelHrm")) || navigationUrl.startsWith("/DjUcNcbvQ0PZ9KGjn3t6OEmC7lq5dO0ckborXyZVTnU0Gd5OPJMjpwLKC48QwHAqcXLWVBnXC5fFwMjNzCNGp5C8fcZ9U7friZIp/antrazal/admin")  ? (
					<></>
				) : (
					<Footer />
				)
			} */}
			{
				isHrmRoute || isSowRoute || (isAuth && currentPath.startsWith("/DjUcNcbvQ0PZ9KGjn3t6OEmC7lq5dO0ckborXyZVTnU0Gd5OPJMjpwLKC48QwHAqcXLWVBnXC5fFwMjNzCNGp5C8fcZ9U7friZIp/antrazal/admin")) ? (
					<></>
				) : (
					(isAuth || localStorage.getItem('authTokenForGoogleLogin') == 'true') && currentPath.startsWith("/DjUcNcbvQ0PZ9KGjn3t6OEmC7lq5dO0ckborXyZVTnU0Gd5OPJMjpwLKC48QwHAqcXLWVBnXC5fFwMjNzCNGp5C8fcZ9U7friZIp/adminPanelHrm") ? (
						<>
						</>
					) : (
						<MainFooter />

					)
				)
			}
		</VoicesThemeShell>
		</VoicesBlogsContext.Provider>
	);
}

export default App;
